import Actions from './action';

export const congratulationInitState = {
	companyInfoCangratulationData: [],
};

const congratulationReducer = (state = congratulationInitState, action) => {
	switch (action.type) {
		case Actions.types.GET_COMPANY_INFO_CONGRATS_SUCCESS: {
			return {
				...state,
				companyInfoCangratulationData: action.res,
			};
		}
		default:
			return state;
	}
};

export default congratulationReducer;
